import { styled } from '@mui/material/styles';
import Link from 'mui/components/elements/Link';

export const StyledRating = styled('div')`
  display: flex;
  flex-flow: row;
  justify-content: center;
  align-items: center;
  gap: 6px;
`;

export const StyledReviewLink = styled(Link)(
  ({ theme }) => `
    color: ${theme.DS_palette.text.secondary};
  `,
);
